module.exports = __webpack_public_path__ + "static/046-f049f46fcb5af9a6f2d02676f2c3e0ca.jpg";